<script setup lang="ts">
import type { FundProjectsItem } from '@store'
import { ROUTES } from '@configs'

const fundStore = useFundStore()
const { fundHistories } = storeToRefs(fundStore)
const { gtEvent } = useGoogleTag()
// 프로젝트 상세 모달 열기
const handleOnOpenFundProjectDetail = (
  projectSn: FundProjectsItem['crfdSurveyPrjctSn'],
  data: any
) => {
  gtEvent('viewEvent', {
    eventCategory: '뷰 이벤트',
    eventAction: '펀드 History 목록',
    eventLabel: '펀드 History 게시글',
    eventSlot: '',
    eventI18nAddr: '펀드 History 게시글',
    eventComponent: 'Button',
    crfdSurveyPrjctSn: data.crfdSurveyPrjctSn,
    crtrNcnm: data.crtrNcnm,
    prjctSjNm: data.prjctSjNm,
    prjctSjNmKo: data.prjctSjNmKo,
    prjctSjNmTh: data.prjctSjNmTh,
    proflFileUrl: data.proflFileUrl,
  })
  useNavigations({
    url: useRoutePathIdChange(ROUTES.FUND_HISTORY_DETAIL.path, {
      id: String(projectSn),
    }),
  })
}
</script>

<template>
  <div class="history-box">
    <NovaBoxFundHistoryItem
      v-for="history in fundHistories.items"
      :key="history.crfdSurveyPrjctSn"
      :source="history"
      @click="
        () => handleOnOpenFundProjectDetail(history.crfdSurveyPrjctSn, history)
      "
    />
  </div>
</template>

<style lang="scss" scoped>
.history-box {
  display: grid;
  grid-gap: 17px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  -webkit-grid-template-columns: repeat(4, minmax(0, 1fr));
  width: 100%;

  @include mobile {
    grid-gap: 12px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    -webkit-grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
